import { FormHelperText as MuiFormHelperText } from '@mui/material';

export default MuiFormHelperText;
